import { TickThinIcon } from "components/icons";

import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

interface CheckboxProps {
  id?: string;
  name?: string;
  value: string | number;
  isChecked?: boolean;
  checkBoxDisabled?: boolean;
  label?: React.ReactNode;
  capitalizeLabel?: boolean;
  className?: string;
  labelClassName?: string;
  onChange?: (value: string, name?: string) => void;
}
const Checkbox = ({
  id,
  name,
  value,
  isChecked = false,
  checkBoxDisabled,
  label,
  capitalizeLabel,
  className,
  labelClassName,
  onChange,
}: CheckboxProps) => {
  const { t } = useTranslationContext();
  const _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(`${value}`, name);
    e.stopPropagation();
  };

  return (
    <div className={cn("flex items-center gap-2 text-night", className)}>
      <div>
        <input
          id={`custom-checkbox-${value}-${id}`}
          className="sr-only peer"
          checked={isChecked}
          type="checkbox"
          value={value}
          onChange={_onChange}
          disabled={checkBoxDisabled}
        />
        <label
          htmlFor={`custom-checkbox-${value}-${id}`}
          className={cn(
            "w-5 h-5 mt-1 border border-gray-400 rounded-sm flex justify-center items-center peer-checked:bg-primary-500 peer-checked:border-primary-500",
            checkBoxDisabled ? "opacity-40" : "cursor-pointer"
          )}
        >
          <div
            className={cn(
              "w-4 h-4 justify-center items-center flex text-white",
              isChecked && "flex"
            )}
          >
            <TickThinIcon />
          </div>
        </label>
      </div>
      {!!label && (
        <div className={cn("pt-1 text-left", labelClassName)}>
          <label
            htmlFor={`custom-checkbox-${value}-${id}`}
            className={cn(
              checkBoxDisabled ? "cursor-not-allowd" : "cursor-pointer",
              capitalizeLabel ? "capitalize" : ""
            )}
          >
            {typeof label === "string" ? t(label) : label}
          </label>
        </div>
      )}
    </div>
  );
};
export default Checkbox;
